module.exports = __webpack_public_path__ + "img/avatar_5.3e8a7bd1.jpg";